import CSSModules from "react-css-modules";
import React from "react";
import styles from './timer.scss';
import PropTypes from "prop-types";
import {formatSecondsCountdown} from "../../utils/dateHelper";
@CSSModules(styles, {allowMultiple: true})
export class Timer extends React.Component {

  static propTypes = {
    time: PropTypes.number, // assuming its in seconds
    onTimerEnd: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      timeLeftToDisplay: this.props.time,
      intervalId: undefined,
    };
  }

  componentDidMount() {
    const intervalId = setInterval(() => {
      const updatedTime = this.state.timeLeftToDisplay - 1;

      this.setState(state => {
        return {
          ...state,
          timeLeftToDisplay: updatedTime,
        };
      });

      if (updatedTime <= 0) {
        clearInterval(this.state.intervalId);
        this.props.onTimerEnd();
      }
    }, 1000);

    this.setState({
      ...this.state,
      intervalId: intervalId
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  render() {
    return <span styleName="text">({formatSecondsCountdown(this.state.timeLeftToDisplay)})</span>;
  }
}



// WEBPACK FOOTER //
// ./src/components/timer/timer.js